const DEV = "https://api.test.lis.ulabcare.com/api/";
const PROD = "https://api.lis.ulabcare.com/api/";

export const baseUrl = PROD;


const DEVIMG = "https://test.lis.ulabcare.com/his/";
const PRODIMG = "https://hospital.ulabcare.com/";

export const baseImg = PRODIMG;


// WEBPACK FOOTER //
// ./src/config/index.js